import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=2a6fa635&"
import script from "./StatsCard.vue?vue&type=script&lang=ts&"
export * from "./StatsCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=2a6fa635&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports